__webpack_require__.p = "/wp-content/plugins/stm/dist/";